import type {
  InternalUsageRequestsQuery,
  OpsSupportRequestsResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Typed wrapper around `GET /v1/ops/support/requests`.
 *
 * The ops-api route is role-gated on `ops-admin` OR `ops-support`;
 * unauthorized callers surface 403 FORBIDDEN which `opsApiRequest`
 * throws as `OpsApiError`. Empty-string fields are omitted so the
 * downstream treats "not provided" as its default rather than an empty
 * filter.
 */

const BASE_PATH = '/v1/ops/support/requests';

export type OpsSupportRequestsQuery = InternalUsageRequestsQuery & { accountId: string };

function buildQueryString(query: OpsSupportRequestsQuery): string {
  const params = new URLSearchParams();
  params.set('accountId', query.accountId);
  if (query.from !== undefined && query.from.length > 0) {
    params.set('from', query.from);
  }
  if (query.to !== undefined && query.to.length > 0) {
    params.set('to', query.to);
  }
  if (query.requestId !== undefined && query.requestId.length > 0) {
    params.set('requestId', query.requestId);
  }
  if (query.limit !== undefined) {
    params.set('limit', String(query.limit));
  }
  if (query.offset !== undefined) {
    params.set('offset', String(query.offset));
  }
  return `?${params.toString()}`;
}

export async function listSupportRequests(
  query: OpsSupportRequestsQuery,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<OpsSupportRequestsResponse> {
  const qs = buildQueryString(query);
  return opsApiRequest<OpsSupportRequestsResponse>(
    `${BASE_PATH}${qs}`,
    { signal },
    fetchImpl,
  );
}
